import { render, staticRenderFns } from "./check-requests.vue?vue&type=template&id=d33e98b0&scoped=true"
import script from "./check-requests.vue?vue&type=script&lang=js"
export * from "./check-requests.vue?vue&type=script&lang=js"
import style0 from "./check-requests.vue?vue&type=style&index=0&id=d33e98b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33e98b0",
  null
  
)

export default component.exports